import React, { useContext, useEffect, useState } from 'react';

import { GlobalContext } from '../../../../store';
import { IGame } from '../../../../store/player/games/store';

import { useBoolean } from '../../../common/Hooks/useBoolean.hook';
import HoleScorers from './Components/HoleScorers';
import { WithdrawPlayer } from './Components/WithdrawPlayer';
import { WithdrawPlayerModal } from './Components/WithdrawPlayerModal';
import { LeaderboardsDrawer } from './Components/LeaderboardsDrawer/LeaderboardsDrawer';
import GroupScorecards from './Components/GroupScorecards/GroupScorecards';

type TProps = Record<'eventId' | 'holeIndex' | 'roundId', number>;

type TSelectedMember = Record<'groupId' | 'gameId', number | null>;

export const SetHoleScores = (props: TProps) => {
  const { roundId, eventId, holeIndex } = props;
  const {
    actions,
    actions: {
      notifications: { pushError, pushSuccess },
      scores: { get: getScores }
    },
    games
  } = useContext(GlobalContext);

  const [game, setGame] = useState<IGame>();
  const [withdrawMode, , onWithdrawToggle] = useBoolean(false);
  const [modalIsOpen, , onModalToggle] = useBoolean(false);
  const [selectedMember, setSelectedMember] = useState<TSelectedMember>({
    gameId: null,
    groupId: null
  });
  const [simpleScorecardsIsVisible, , toggleSimpleScorecardsIsVisible] = useBoolean(false);

  useEffect(() => {
    if (Object.values(games).length > 0 && roundId) {
      const newCurrentGame: IGame = Object.values(games).find(g => g.round.id === Number(roundId));

      setGame(newCurrentGame);
    }
  }, [games, roundId]);

  useEffect(() => {
    if (game) {
      getScores(game.group.id);
    }
  }, [game]);

  const cancelPlayerWithdraw = () => {
    setSelectedMember({ groupId: null, gameId: null });

    onModalToggle();
  };

  const selectPlayerToWithdraw = (gameId: number, groupId: number) => () => {
    setSelectedMember({ gameId, groupId });

    onModalToggle();
  };

  const onPlayerWithdraw = async () => {
    const { groupId, gameId } = selectedMember;

    if (!!groupId && !!gameId) {
      const response = await actions.games.updateGamePlayerStatus(groupId, gameId, 'withdraw');

      if (response && response.errors) {
        await pushError('PLAYER COULD NOT BE WITHDRAWN');
      } else {
        pushSuccess('THE PLAYER HAS BEEN WITHDRAWN FROM THE EVENT');
      }
    }

    setSelectedMember({ groupId: null, gameId: null });
  };

  return game ? (
    <>
      <div
        className={`score-route set-hole-scores view-scores ${withdrawMode ? '' : 'has-header'}`}
      >
        <div className="animation-scores">
          <HoleScorers
            game={game}
            eventId={eventId}
            holeIndex={holeIndex}
            roundId={roundId}
            simpleScorecardsIsVisible={simpleScorecardsIsVisible}
            withdrawMode={withdrawMode}
            onWithdrawToggle={onWithdrawToggle}
            toggleScorecardsDrawerOpen={toggleSimpleScorecardsIsVisible}
          />

          <WithdrawPlayer
            withdrawMode={withdrawMode}
            game={game}
            selectPlayerToWithdraw={selectPlayerToWithdraw}
            onWithdrawToggle={onWithdrawToggle}
          />

          <WithdrawPlayerModal
            modalIsOpen={modalIsOpen}
            onPlayerWithdraw={onPlayerWithdraw}
            cancelPlayerWithdraw={cancelPlayerWithdraw}
          />

          <GroupScorecards
            withdrawMode={simpleScorecardsIsVisible}
            toggleSimpleScorecardsIsVisible={toggleSimpleScorecardsIsVisible}
            game={game}
          />
        </div>
      </div>

      <LeaderboardsDrawer eventId={eventId} roundId={roundId} holeIndex={holeIndex} />
    </>
  ) : (
    <> </>
  );
};
